<template>
  <div id="app">
    <b-container>
      <b-row class="p-3" v-if="isAuthenticated">
        <b-col cols="1">
          <b-img src="/images/hayek2.png" height="32"></b-img>
        </b-col>
        <b-col class="text-right">
          <b-button v-b-modal.modal-reminder variant="link"><font-awesome-icon :icon="['fa-regular', 'fa-clock']" /> Remind Me</b-button>
          <a href="/inbox/message"><font-awesome-icon :icon="['fa-solid', 'fa-inbox']" class="ml-3" /> Inbox</a>
          <span @click="goNotifications" id="notification-menu"><font-awesome-icon :icon="notification_icon" class="ml-3" id="notification_bell" /> {{ notification_count }}</span>

          <b-popover target="notification-menu" triggers="click" placement="bottomleft">
                    <b-list-group flush class="m-0" v-if="notifications.length > 0">
                      <b-list-group-item v-for="result in notifications" :key="result.id">
                        <a :href="result.url">{{ result.title }}</a>
                      </b-list-group-item>
                    </b-list-group>
                    <b-list-group flush v-else>
                      <b-list-group-item>No notifications</b-list-group-item>
                    </b-list-group>
                  </b-popover>
          <a href="/profile/edit"><font-awesome-icon :icon="['fa-solid', 'fa-gear']" class="ml-3" /></a>
          <a href="/logout"><font-awesome-icon :icon="['fa-solid', 'fa-arrow-right-from-bracket']" class="ml-3" /> Logout</a>
        </b-col>
      </b-row>
      <b-card title="Card Title" no-body>
        <b-card-header header-tag="nav" class="p-0">
          <b-navbar card-header toggleable="lg" sticky v-if="isAuthenticated">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav>
                <b-nav-item href="/dashboard">Dashboard</b-nav-item>
                <b-nav-item href="/policies">Policies</b-nav-item>
                <b-nav-item href="/tasks">Tasks
                  <b-badge variant="success" class="m-1">{{
            task_counter.tasks_new
          }}</b-badge>
                  <b-badge variant="danger" class="m-1">{{
              task_counter.tasks_overdue
            }}</b-badge>
                  <b-badge variant="warning" class="m-1">{{
              task_counter.tasks_count
            }}</b-badge>
                </b-nav-item>
                <b-nav-item href="/docs">Docs</b-nav-item>
                <b-nav-item-dropdown text="Reports" v-if="is_admin == 1">                  
                  <b-dropdown-item href="/report/total-premium-volume">Total Premium Volume</b-dropdown-item>
                  <b-dropdown-item href="/report/user-summary">Active User Summary</b-dropdown-item>
                  <b-dropdown-item href="/report/user-policy-summary">User Policy Summary</b-dropdown-item>
                  <b-dropdown-item href="/report/user-logins">User Recent Logins</b-dropdown-item>
                  <b-dropdown-item href="/report/user-activity">User Activity Logs</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown text="Admin" v-if="is_admin == 1">
                  <b-dropdown-item href="/admin/company">Company Settings</b-dropdown-item>
                  <b-dropdown-item href="/admin/users">Users</b-dropdown-item>
                  <b-dropdown-item href="/admin/system-messages">System Messages</b-dropdown-item>
                  <hr>
                  <b-dropdown-item href="/admin/canned-notes">Canned Notes</b-dropdown-item>
                  <b-dropdown-item href="/admin/linesofcoverage">Lines of Coverage</b-dropdown-item>
                  <b-dropdown-item href="/admin/risktypes">Risk Types</b-dropdown-item>
                  <b-dropdown-item href="/admin/insurance-companies">Insurance Companies</b-dropdown-item>
                  <b-dropdown-item href="/admin/general-agents">General Agents</b-dropdown-item>
                  <hr>
                  <b-dropdown-item href="/export/mailing-list">Export Mailing List</b-dropdown-item>
                  <b-dropdown-item href="/export/policies">Export Active Policies</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form @submit.prevent="goSearch">
                  <b-form-input class="mr-sm-2" placeholder="Search policies, aspects..." v-model="search_terms"
                    @keyup="search" @keyup.enter="goSearch" id="search-input"></b-form-input>
                  <b-button variant="primary" class="my-sm-0" id="search-menu"
                    @click="goSearch"><b-icon-search />
                  </b-button>
                  <b-popover target="search-input" triggers="focus" placement="bottomleft" custom-class="search-popover">
                    <div v-if="search_results.length > 0" style="max-height: 400px; overflow-y: auto;">
                      <b-list-group flush>
                        <b-list-group-item v-for="(result, index) in search_results" :key="index" :href="result.url" class="d-flex align-items-center py-2">
                          <font-awesome-icon :icon="result.icon" class="mr-2 text-muted" style="width: 18px;" />
                          <div class="flex-grow-1 text-truncate">
                            <div class="text-truncate">{{ result.title }}</div>
                          </div>
                          <b-badge :variant="result.type === 'policy' ? 'primary' : 'secondary'" class="ml-2" pill>{{ result.type_label }}</b-badge>
                        </b-list-group-item>
                      </b-list-group>
                      <div class="text-center py-2">
                        <a href="#" @click.prevent="goSearch" class="small">View all results</a>
                      </div>
                    </div>
                    <div v-else-if="search_terms.length >= 2" class="p-3 text-center text-muted" style="">
                      No results found
                    </div>
                    <div v-else class="p-3 text-center text-muted" style="">
                      Type to search...
                    </div>
                  </b-popover>
                  <b-nav-item-dropdown class="mx-3" text="+ New">
                    <b-dropdown-item href="/aspect/new">Aspect</b-dropdown-item>
                    <b-dropdown-item href="/policy/new">Policy</b-dropdown-item>
                    </b-nav-item-dropdown> 
                </b-nav-form>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>

        </b-card-header>

        <b-card-body class="p-0 m-2">
          <b-container class="m-0 p-0 mt-2">

                <div class="messages" v-if="messages.length > 0">
                  <b-alert variant="info" dismissible show v-for="message in messages" :key="message.id"
                    @dismissed="mark_read(message.id)">
                    <h2><font-awesome-icon :icon="['fa-solid', 'fa-circle-info']" /> {{ message.subject }}</h2>
                    <span v-html="message.body"></span>
                  </b-alert>
                </div>

                <b-alert v-if="alert" :show="alert.show" :variant="alert.variant" v-html="alert.message" dismissible></b-alert>

                <router-view @error="error" @alert="catch_alert" @theme="updateTheme" />

                <br clear="all"> 
            <div class="mb-2 text-center">
              <hr />
              &copy; Hayek Insurance Company
            </div>
          </b-container>

        </b-card-body>
      </b-card>
    </b-container>
    <b-modal id="modal-reminder">
      <template #modal-title><font-awesome-icon :icon="['fa-regular', 'fa-clock']" /> New Reminder</template>
    <b-form-group label="Remind me about this">
      <b-form-select id="opt_reminder" v-model="reminder_selected" :options="reminder_options" ></b-form-select>
    </b-form-group>
    <b-form-group>
      <b-form-textarea v-model="reminder"></b-form-textarea>
    </b-form-group>
    <template #modal-footer>
      <b-button variant="primary" @click="send_reminder" id="send_reminder">Set Reminder</b-button>
    </template>
  </b-modal>
  </div>
</template>

<script>
import SearchDataService from "./services/SearchDataService";
import ReferenceDataService from "./services/ReferenceDataService";
import FormDataService from "./services/FormDataService";
import MessageDataService from "./services/MessageDataService";
import TaskDataService from "./services/TaskDataService";
import CompanyDataService from "@/services/CompanyDataService";
import ReminderDataService from "./services/ReminderDataService";
import { EventBus } from './eventBus';
export default {
  data() {
    return {
      isAuthenticated: localStorage.getItem("isAuthenticated"),
      search_terms: "",
      search_results: [],
      search_icons: ReferenceDataService.aspect_icons(),
      search_type_labels: { policy: 'Policy' },
      task_counter: {},
      debounce: null,
      company_id: localStorage.getItem("company_id"),
      theme: null,
      messages: [],
      notification_icon: ["fa-regular", "fa-bell"],
      notification_count: 0,
      notifications: [],
      alert: {
        show: false,
        variant: '',
        message: ''
      },
      is_admin: localStorage.getItem("admin"),
      reminder: `Reminder for ${this.$route.meta.title}`,
      reminder_options: [
        { value: "20", text: "in 20 minutes" },
        { value: "60", text: "in 1 hour" },
        { value: "180", text: "in 3 hours" },
        { value: "tomorrow", text: "tomorrow at 9am" },
        { value: "nextweek", text: "next week Monday at 9am" },
        { value: "custom", text: "custom" },
      ],
      reminder_selected: 20,
    };
  },
  async created() {
    EventBus.$on('http-error', this.handleHttpError);

    const hasToken = localStorage.getItem('jwt');
    if (this.isAuthenticated && hasToken) {
      await this.fetchAndSetTheme();
      this.initializeTaskCounter();
      this.initializeMessages();
      this.initializeReminders();
      this.initializePusherSubscriptions();
      FormDataService.list().then((res) => {
        const forms = res?.data || res;
        if (forms && Array.isArray(forms)) {
          forms.forEach(f => {
            this.search_type_labels[f.id] = f.name;
          });
        }
      }).catch(() => {});
    } else {
      this.redirectToLoginIfNotAuthenticated();
    }
  },
    beforeDestroy() {
    EventBus.$off('http-error', this.handleHttpError);
  },
  watch: {
    $route() {
      if (this.isAuthenticated && localStorage.getItem('jwt')) {
        this.initializeMessages();
      }
    },
    notification_count(newCount) {
      this.notification_icon = newCount > 0 ? ["fa-solid", "fa-bell"] : ["fa-regular", "fa-bell"];
    },
  },
  methods: {
    handleHttpError(error) {
      // Redirect to login on 401 Unauthorized
      if (error.status === 401) {
        localStorage.removeItem('jwt');
        localStorage.removeItem('isAuthenticated');
        this.redirectToLoginIfNotAuthenticated();
        return;
      }
      const m = error.message;
      let text;
      if (typeof m === 'string') {
        text = m;
      } else if (m && typeof m === 'object') {
        text = m.error || m.message || JSON.stringify(m);
      } else {
        text = 'An error occurred.';
      }
      this.alert = {
        show: true,
        variant: 'danger',
        message: text
      };
    },    
    // Initialize the task counter from session storage or fetch from the API
    initializeTaskCounter() {
      const task_counts = JSON.parse(localStorage.getItem("task_counts") || "null");
      if (task_counts) {
        this.task_counter = task_counts;
      } else {
        TaskDataService.getTaskCounts().then((res) => {
          if (res && res.data) {
            localStorage.setItem("task_counts", JSON.stringify(res.data));
            this.task_counter = res.data;
          }
        }).catch(() => {
          this.task_counter = {};
        });
      }
    },

    // Fetch unread messages
    initializeMessages() {
      MessageDataService.getAllUnread().then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.messages = res.data;
        } else {
          this.messages = [];
        }
      }).catch(() => {
        this.messages = [];
      });
    },

    // Fetch due reminders and add to notifications
    initializeReminders() {
      ReminderDataService.getAll().then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          // Filter for due reminders (remind_at is in the past)
          const now = new Date();
          const dueReminders = res.data.filter(reminder => {
            const remindAt = new Date(reminder.remind_at);
            return remindAt <= now;
          });

          // Convert reminders to notification format and add to notifications
          dueReminders.forEach(reminder => {
            this.notifications.push({
              id: `reminder-${reminder.id}`,
              title: reminder.message,
              url: reminder.link || '/reminders'
            });
          });

          this.notification_count = this.notifications.length;
        }
      }).catch((err) => {
        console.error('Failed to fetch reminders:', err);
      });
    },

    // Set up pusher subscriptions
    initializePusherSubscriptions() {
      const globalChannel = this.$pusher.subscribe("global-channel");
      const userChannel = this.$pusher.subscribe(localStorage.getItem("pusher_user"));

      globalChannel.bind("notification", this.handleNotification);
      userChannel.bind("notification", this.handleNotification);
    },

    handleNotification(data) {
      this.notifications.push(data);
      this.notification_count++;
    },

    // Redirect unauthenticated users to the login page
    redirectToLoginIfNotAuthenticated() {
      const publicPaths = ["/", "/login", "/reset-password", "/reset-code"];
      if (!publicPaths.includes(this.$route.path)) {
        this.$router.push("/");
      }
    },

    // Fetch and set the theme
    fetchAndSetTheme() {
      if (!this.company_id) return;
      CompanyDataService.getById(this.company_id).then((res) => {
        if (res && res.data && res.data.theme) {
          this.theme = res.data.theme;
          this.updateTheme(this.theme);
        }
      }).catch(() => {
        // Use default theme on error
      });
    },

    updateTheme(theme) {
      let link = document.getElementById("theme-css");
      if (!link) {
        link = document.createElement("link");
        link.id = "theme-css";
        link.rel = "stylesheet";
        document.head.appendChild(link);
      }
      link.href = `https://cdn.jsdelivr.net/npm/bootswatch@4.5.2/dist/${theme}/bootstrap.min.css`;
    },

    // Send a reminder
    send_reminder() {
      const reminder_button = document.getElementById("send_reminder");
      reminder_button.disabled = true;

      ReminderDataService.create({
        message: this.reminder,
        when: this.reminder_selected,
        link: this.$route.path,
      }).then(() => {
        reminder_button.classList.add("btn-success");
        reminder_button.innerText = "Reminder Set!";
        this.$bvModal.hide("modal-reminder");
      });
    },

    // Mark a message as read
    mark_read(id) {
      MessageDataService.read(id);
    },

    // Perform a search
    search() {
      if (this.search_terms.length < 2) {
        this.search_results = [];
        return;
      }

      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        SearchDataService.filtered(this.search_terms, null).then((res) => {
          if (res && res.data && Array.isArray(res.data)) {
            this.search_results = res.data.map((result) => ({
              title: result.title,
              url: result.url.replace("aspect/view", "aspect").replace("policies/view", "policy"),
              icon: this.search_icons[result.icon] || 'fa-solid fa-file',
              type: result.type,
              type_label: this.search_type_labels[result.type] || result.type || 'Other',
            }));
          } else {
            this.search_results = [];
          }
        }).catch(() => {
          this.search_results = [];
        });
      }, 300);
    },

    // Navigate to the notifications popover
    goNotifications() {
      this.$root.$emit("bv::show::popover", "notification-menu");
    },

    // Redirect to search results page
    goSearch() {
      if (!this.search_terms || this.search_terms.length < 2) return;
      window.location = `/search/?q=${encodeURIComponent(this.search_terms)}`;
    },

    // Handle global alert messages
    catch_alert(message) {
      this.alert = {
        show: true,
        variant: message.variant,
        message: message.message,
      };
    },

    // Handle general errors
    error(err) {
      console.error(err);
    },
  },
};
</script>

<style>
* {
  font-family: "Open Sans", sans-serif;
}

.search-popover.popover {
  max-width: 400px;
  width: 400px;
}

.search-popover .popover-body {
  padding: 0;
  overflow: hidden;
}

h1,
h2,
h3 {
  font-weight: bold;
}

h1 {
  font-size: 24pt !important;
}

h2 {
  font-size: 18pt !important;
}

h3 {
  font-size: 16pt !important;
}

.error-message {
  font-size: 10pt;
}
</style>
